import { haptic } from '../telegram/haptics.ts'

export interface SegmentOption<T extends string> {
  value: T
  label: string
  attn?: boolean
}

interface SegmentedControlProps<T extends string> {
  options: SegmentOption<T>[]
  value: T
  onChange: (v: T) => void
  label: string
}

export function SegmentedControl<T extends string>({
  options,
  value,
  onChange,
  label,
}: SegmentedControlProps<T>) {
  return (
    <fieldset className="segmented" aria-label={label}>
      {options.map((o) => {
        const active = o.value === value
        return (
          <button
            key={o.value}
            type="button"
            aria-pressed={active}
            className={`segmented__item${active ? ' segmented__item--active' : ''}${o.attn ? ' segmented__item--attn' : ''}`}
            onClick={() => {
              if (!active) haptic.selection()
              onChange(o.value)
            }}
          >
            {o.label}
          </button>
        )
      })}
    </fieldset>
  )
}
